import { AuthGuard, CmsConfig } from '@spartacus/core';
import {
  AdminGuard,
  UserGuard,
} from '@spartacus/organization/administration/core';
import { ROUTE_PARAMS } from '@spartacus/organization/administration/root';
import {
  ItemService,
  ListComponent,
  ListService,
  UserApproverListComponent,
  UserAssignedApproverListComponent,
  UserAssignedPermissionListComponent,
  UserAssignedUserGroupListComponent,
  UserFormComponent,
  UserItemService,
  UserListService,
  UserPermissionListComponent,
  UserUserGroupListComponent
} from "@spartacus/organization/administration/components";
import {GonvarriUserDetailsComponent} from "../../components/gonvarri-user-details/gonvarri-user-details.component";
import {
  GonvarriUserChangePasswordFormComponent
} from "../../components/gonvarri-user-change-password-form/gonvarri-user-change-password-form.component";
import { GonvarriUserListService } from '../services/gonvarri-user-list.service';

export const gonvarriUserCmsConfig: CmsConfig = {
  cmsComponents: {
    ManageUsersListComponent: {
      component: ListComponent,
      providers: [
        {
          provide: ListService,
          useExisting: GonvarriUserListService,
        },
        {
          provide: ItemService,
          useExisting: UserItemService,
        },
      ],
      childRoutes: {
        children: [
          {
            path: 'create',
            component: UserFormComponent,
            canActivate: [UserGuard],
          },
          {
            path: `:${ROUTE_PARAMS.userCode}`,
            component: GonvarriUserDetailsComponent,
            data: {
              cxPageMeta: { breadcrumb: 'orgUser.breadcrumbs.details' },
            },
            children: [
              {
                path: `edit`,
                component: UserFormComponent,
                canActivate: [UserGuard],
              },
              {
                path: `change-password`,
                component: GonvarriUserChangePasswordFormComponent,
                canActivate: [UserGuard],
              },
              {
                path: 'user-groups',
                data: {
                  cxPageMeta: { breadcrumb: 'orgUser.breadcrumbs.userGroups' },
                },
                children: [
                  {
                    path: '',
                    component: UserAssignedUserGroupListComponent,
                  },
                  {
                    path: 'assign',
                    component: UserUserGroupListComponent,
                  },
                ],
              },
              {
                path: 'approvers',
                data: {
                  cxPageMeta: { breadcrumb: 'orgUser.breadcrumbs.approvers' },
                },
                children: [
                  {
                    path: '',
                    component: UserAssignedApproverListComponent,
                  },
                  {
                    path: 'assign',
                    component: UserApproverListComponent,
                  },
                ],
              },
              {
                path: 'purchase-limits',
                data: {
                  cxPageMeta: { breadcrumb: 'orgUser.breadcrumbs.permissions' },
                },
                children: [
                  {
                    path: '',
                    component: UserAssignedPermissionListComponent,
                  },
                  {
                    path: 'assign',
                    component: UserPermissionListComponent,
                  },
                ],
              },
            ],
          },
        ],
      },
      guards: [AuthGuard, AdminGuard],
    },
  },
};
